import React from 'react';
import { Button } from '@/components/ui/button';
import { useTheme } from '@/contexts/ThemeContext';
import { useLanguage } from '@/contexts/LanguageContext';
import { Moon, Sun } from '@phosphor-icons/react';

export const ThemeToggle = ({ className = '' }) => {
  const { isDark, toggleTheme } = useTheme();
  const { language } = useLanguage();
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleTheme}
      className={`text-[#655dc6] hover:bg-[#E8E6F5] ${className}`}
      title={isDark
        ? (language === 'ar' ? 'الوضع الفاتح' : 'Light mode')
        : (language === 'ar' ? 'الوضع الداكن' : 'Dark mode')}
      data-testid="theme-toggle-btn"
    >
      {isDark ? <Sun size={20} weight="duotone" /> : <Moon size={20} weight="duotone" />}
    </Button>
  );
};

export default ThemeToggle;
